import React, { Component } from "react";
import { CircularProgress } from '@material-ui/core';
import "../../assets/css/common/common.scss";

class LoaderComponent extends Component {
  render() {
    return (
      <div className="xion-loader" style={{ display: "none" }}>
        <div className="loader">
          <CircularProgress />
        </div>
      </div>
    );
  }
}

export default LoaderComponent;
